/**
 * We have feature flagging at home
 * This is the DEPRECATED OLD VERSION OF FEATURE FLAGGING.
 * Do not write new code here.
 *
 * This enables feature flags at build time (per environment) for all customers.
 */

export const legacyFeatureFlags = {
    billing: import.meta.env.VITE_BILLING === '1',
    googleIntegration: import.meta.env.VITE_GOOGLE_INTEGRATION === '1',
};
